import { getMessage } from "../../../../services/graphql/queries/messageConfiguration";
import {withApollo} from "react-apollo"
import React from "react"
import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import { withRouter } from "react-router-dom";
import ReactModal from "../../../Common/ReactModal";
class SmsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priority: "",
      msgTemplate: "",
      message: {},
      Id: "",
      reactModalVisible: false,
      modalMessage: "You dont have permission to do this Action",
      Message_Configuration_Sms_Feature_ID: 175
    };
    this.getData = this.getData.bind(this);
    this.changeMode = this.changeMode.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }
  changeMode() {
    if (
      this.props.accessSpecifier[
        this.state.Message_Configuration_Sms_Feature_ID
      ].editP
    ) {
      this.props.toggleMode(true);
    } else {
      this.setState({ reactModalVisible: true });
    }
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  getData() {
    console.log("SmsView", this.props.message);
    this.props.client
      .query({
        query: getMessage,
        variables: {
          messageId: parseInt(this.state.Id),
          deliveryMode: "SMS"
        },

        fetchPolicy: "network-only"
      })
      .then(result => {
        const message = result.data.getMessage;
        console.log("result~~~~", message);

        this.setState({ ...message });
        this.props.setSMSData(message);
      })
      .catch(error => {
        error.graphQLErrors.map(({ message }, i) => {
          this.setState(prevState => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }
  // componentWillReceiveProps(nextProps) {
  //   console.log("props", nextProps);
  //   if (nextProps.message && nextProps.message.Id) {
  //     this.state.Id = nextProps.message.Id;
  //     // this.getData();
  //   }
  // }
  componentDidMount() {
    if (this.props.message && this.props.message.Id) {
      this.state.Id = this.props.message.Id;
      this.getData();
    }
  }

  render() {
    const {
      msgTemplate,
      priority,
      reactModalVisible,
      modalMessage
    } = this.state;
    console.log("message,", priority);
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={false}
        />
        <div
          className="tab-pane fade show active"
          id="msg"
          role="tabpanel"
          aria-labelledby="msg-tab"
        >
          <div className="box-card">
            <div className="row align-items-center">
              <div className="col-md-10">
                <h1 className="heading m-b-0">Sms Details</h1>
              </div>
            </div>
            <div className="alert alert-success p-0 m-t-10 m-b-0" role="alert">
              {this.props && this.props.isSuccess ? (
                <span>
                  <img src="/static/images/svg/Success.svg" />
                  Success
                </span>
              ) : null}
            </div>
            <div className="row mt-3">
              <div className="col-md-12 col-lg-12">
                <div className="row ">
                  <div className="col-md-12 col-lg-3">
                    <div className="form-group">
                      <label>
                        Priority<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        readOnly
                        className="form-control-plaintext"
                        value={this.state.priority}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>
                        Message<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        type="text"
                        readOnly
                        className="form-control-plaintext text-medium"
                        id="textarea"
                        value={this.state.msgTemplate}
                      />
                    </div>
                    <br />
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={this.changeMode}
                    >
                      Modify
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withApollo(SmsView);
